import InventoryIngredientList from './InventoryIngredientList'

export default { list: InventoryIngredientList }
